import React, { memo } from 'react';

import * as Styles from './styles';

interface IProps {
  img: string;
}

const ImagePlaceholderComponent: React.FC<IProps> = ({ img }) => {
  return <Styles.ImageContainer srcImage={img}></Styles.ImageContainer>;
};

export const ImagePlaceholder = memo(ImagePlaceholderComponent);
